import { render, staticRenderFns } from "./LoanPaymentsDeactivated.vue?vue&type=template&id=522398d1"
import script from "./LoanPaymentsDeactivated.vue?vue&type=script&lang=js"
export * from "./LoanPaymentsDeactivated.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports